import React, { useMemo } from "react";
import { SensorDataSession, Station } from "@shared/models";

import "./index.scss";

interface SensorDataSessionStationsItemProps {
  station: Partial<Station>;
  session?: SensorDataSession | null;
  onDownload: () => void;
}

const SensorDataSessionStationsItem = (props: SensorDataSessionStationsItemProps) => {
  const { station, session, onDownload } = props;

  const timeRange = useMemo(() => {
    if (!session) return "-";

    const stationStartDate = new Date(String(session.station_start_date)).toLocaleString();
    const stationEndDate = new Date(String(session.station_end_date)).toLocaleString();
    return `${stationStartDate} - ${stationEndDate}`;
  }, [session]);

  return (
    <div className="sensor-data-session-station" style={{ borderLeft: `5px solid ${station.color}` }}>
      <div className="left-sensor-data-session-station" style={{ color: station.color }}>
        <div className="station-name">{station.station_code}</div>
        <div className="station-name download-csv" onClick={() => onDownload()}>
          Download CSV
        </div>
      </div>
      {session ? (
        <div className="right-sensor-data-session-file">
          <div className="value-item">
            <div className="label">Time Range</div>
            <div className="text">{timeRange}</div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default SensorDataSessionStationsItem;
